import { Const } from "../../../../Const";
import { RenderState } from "../../../../RenderDriver/RenderModuleData/Design/RenderState";
import { Shader3D } from "../../../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../../../layagl/LayaGL";
import { Vector2 } from "../../../../maths/Vector2";
import { Vector4 } from "../../../../maths/Vector4";
import { BaseTexture } from "../../../../resource/BaseTexture";
import { Texture } from "../../../../resource/Texture";
import { ShaderDefines2D } from "../ShaderDefines2D";
export var RenderSpriteData;
(function (RenderSpriteData) {
    RenderSpriteData[RenderSpriteData["Zero"] = 0] = "Zero";
    RenderSpriteData[RenderSpriteData["Texture2D"] = 1] = "Texture2D";
    RenderSpriteData[RenderSpriteData["Primitive"] = 2] = "Primitive";
})(RenderSpriteData || (RenderSpriteData = {}));
export class Value2D {
    constructor(mainID) {
        this._needRelease = false;
        this.mainID = RenderSpriteData.Zero;
        this.ref = 1;
        this._cacheID = 0;
        this.mainID = mainID;
        Value2D.prototype.initialize.call(this);
    }
    initialize() {
        let mainID = this.mainID;
        this.shaderData = this.shaderData || LayaGL.renderDeviceFactory.createShaderData(null);
        if (this.mainID == RenderSpriteData.Texture2D) {
            this.shaderData.addDefine(ShaderDefines2D.TEXTURESHADER);
        }
        if (this.mainID == RenderSpriteData.Primitive) {
            this.shaderData.addDefine(ShaderDefines2D.PRIMITIVESHADER);
        }
        this.textureHost = null;
        this.clipMatDir = new Vector4(Const.MAX_CLIP_SIZE, 0, 0, Const.MAX_CLIP_SIZE);
        this.clipMatPos = new Vector2();
        this._cacheID = mainID;
        let cache = Value2D._cache[this._cacheID];
        if (mainID > 0 && !cache) {
            cache = Value2D._cache[this._cacheID] = [];
            cache._length = 0;
        }
        this.shaderData.setBool(Shader3D.DEPTH_WRITE, false);
        this.shaderData.setInt(Shader3D.DEPTH_TEST, RenderState.DEPTHTEST_OFF);
        this.shaderData.setInt(Shader3D.BLEND, RenderState.BLEND_ENABLE_ALL);
        this.shaderData.setInt(Shader3D.BLEND_EQUATION, RenderState.BLENDEQUATION_ADD);
        this.shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ONE);
        this.shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
        this.shaderData.setNumber(ShaderDefines2D.UNIFORM_VERTALPHA, 1.0);
        this.shaderData.setInt(Shader3D.CULL, RenderState.CULL_NONE);
    }
    reinit() {
        this.initialize();
    }
    static _initone(type, classT) {
        Value2D._compileDefine = LayaGL.unitRenderModuleDataFactory.createDefineDatas();
        Value2D._typeClass[type] = classT;
        Value2D._cache[type] = [];
        Value2D._cache[type]._length = 0;
    }
    static create(mainType) {
        var types = Value2D._cache[mainType] ? Value2D._cache[mainType] : [];
        if (types._length) {
            let sv = types[--types._length];
            sv.reinit();
            return sv;
        }
        else
            return new Value2D._typeClass[mainType]();
    }
    set size(value) {
        this.shaderData.setVector2(ShaderDefines2D.UNIFORM_SIZE, value);
    }
    get size() {
        return this.shaderData.getVector2(ShaderDefines2D.UNIFORM_SIZE);
    }
    set vertAlpha(value) {
        this.shaderData.setNumber(ShaderDefines2D.UNIFORM_VERTALPHA, value);
    }
    get vertAlpha() {
        return this.shaderData.getNumber(ShaderDefines2D.UNIFORM_VERTALPHA);
    }
    set mmat(value) {
        this.shaderData.setMatrix4x4(ShaderDefines2D.UNIFORM_MMAT, value);
    }
    get mmat() {
        return this.shaderData.getMatrix4x4(ShaderDefines2D.UNIFORM_MMAT);
    }
    set u_MvpMatrix(value) {
        this.shaderData.setMatrix4x4(ShaderDefines2D.UNIFORM_MVPMatrix, value);
    }
    get u_MvpMatrix() {
        return this.shaderData.getMatrix4x4(ShaderDefines2D.UNIFORM_MVPMatrix);
    }
    get textureHost() {
        return this._textureHost;
    }
    set textureHost(value) {
        this._textureHost = value;
        let textrueReadGamma = false;
        if (this.textureHost) {
            if (this.textureHost instanceof BaseTexture) {
                textrueReadGamma = this.textureHost.gammaCorrection != 1;
            }
            else if (this.textureHost instanceof Texture && this.textureHost.bitmap) {
                textrueReadGamma = this.textureHost.bitmap.gammaCorrection != 1;
            }
        }
        if (textrueReadGamma) {
            this.shaderData.addDefine(ShaderDefines2D.GAMMATEXTURE);
        }
        else {
            this.shaderData.removeDefine(ShaderDefines2D.GAMMATEXTURE);
        }
        let tex;
        if (value instanceof Texture) {
            tex = value.bitmap;
        }
        else {
            tex = value;
        }
        this.shaderData.setTexture(ShaderDefines2D.UNIFORM_SPRITETEXTURE, tex);
    }
    set color(value) {
        value && this.shaderData.setVector(ShaderDefines2D.UNIFORM_COLOR, value);
    }
    get color() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_COLOR);
    }
    set colorAdd(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_COLORADD, value);
    }
    get colorAdd() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_COLORADD);
    }
    set clipMatDir(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_CLIPMATDIR, value);
    }
    get clipMatDir() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_CLIPMATDIR);
    }
    set clipMatPos(value) {
        this.shaderData.setVector2(ShaderDefines2D.UNIFORM_CLIPMATPOS, value);
    }
    get clipMatPos() {
        return this.shaderData.getVector2(ShaderDefines2D.UNIFORM_CLIPMATPOS);
    }
    upload(material, shaderData) {
    }
    setFilter(value) {
        if (!value)
            return;
        this.shaderData.addDefine(value.typeDefine);
    }
    clear() {
        if (this.shaderData) {
            this.shaderData.clearDefine();
        }
        this.textureHost = null;
    }
    blendNormal() {
        this.shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_SRC_ALPHA);
        this.shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
    }
    blendPremulAlpha() {
        this.shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ONE);
        this.shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
    }
    blendAdd() {
        this.shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ONE);
        this.shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE);
    }
    blendMask() {
        this.shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ZERO);
        this.shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_SRC_ALPHA);
    }
    release() {
        if ((--this.ref) < 1) {
            let cache = Value2D._cache[this._cacheID];
            cache && (cache[cache._length++] = this);
            this.clear();
            this.filters = null;
            this.ref = 1;
        }
    }
}
Value2D._cache = [];
Value2D._typeClass = [];
export class Value2DManager {
}
